import axios from "axios";

export const deleteDueDiligenceDoc = (
  dueDiligenceDocId: number,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/delete/one/customer.due_diligence_document/${dueDiligenceDocId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
